import { Base } from 'src/app/shared/model/core/base.model';
import {Persona} from './persona.model';
import {Perfil} from './perfil.model';

export class Usuario extends Base{

  public id: number;

  public user_nom: string;
  public password: string; 

  public sitio: string;
  
  public persona : Persona;
  public perfiles : Array<Perfil>
  public nombrePersona: string;

  public num_cliente: number
  public id_persona: number;
  public nombrecompleto: string;
  public fotoPerfil: string;
  public idCorporativo: number
  public idEmpresa: number
  /** EMPLEADO o CLIENTE: decide si entra al COS o al portal de clientes. */
  public tipoUsuario: string
    
  public slidder: boolean;
  public totalPaginas :Array<number>;
  public itemInicial:number;
  public pNumItems:number;
  public param: string;
  public item: number;
  public estatus: string;
  public check: boolean = false;
 
  public newPassword: string; 
  public coincide: string;
  public intentos: number;

  public horasTrabajadas: number;
	public horasTrabajadasStr: string;
	public historial: Array<any>;
  //agregar variable nueva
  public token_personal: string;
  public token_azure: string;
  public permisoProyectos: boolean;
}
